export interface DimensionInfo {
  name: string;
  hierarchies: HierarchyInfo[];
}

export interface HierarchyInfo {
  name: string;
  levels: string[];
}

export interface MeasureInfo {
  name: string;
  caption: string;
  /** Vide pour une mesure calculée sans groupe associé. */
  measureGroup: string;
  /** Mesure calculée du script du cube (absent sur les anciens backends). */
  isCalculated?: boolean;
}

/** Groupe affiché : les mesures calculées sans groupe sont rangées sous « Calculs ». */
export const measureGroupLabel = (m: MeasureInfo) => m.measureGroup || "Calculs";

export interface MdxQueryRequest {
  cubeName: string;
  measures: string[];
  rows: DimensionSelection[];
  columns: DimensionSelection[];
  dateFrom?: string;
  dateTo?: string;
  periods?: { label: string; dateFrom: string; dateTo: string }[];
  /** Top N calculé par SSAS (TOPCOUNT) : seules les N meilleures lignes reviennent. */
  topCount?: number;
  /** Mesure de classement du Top N (doit figurer dans `measures`). */
  topBy?: string;
  /** NON EMPTY sur les lignes (défaut côté backend : true). */
  nonEmpty?: boolean;
  /** Demande à SSAS les lignes/colonnes « All » (totaux) aussi pour les hiérarchies multi-niveaux. */
  includeTotals?: boolean;
}

export interface DimensionSelection {
  dimensionName: string;
  hierarchyName?: string;
  levelName?: string;
  members?: string[];
  /** Membres dépliés (drill-down), par nom unique MDX. */
  expanded?: string[];
}

/** Membre d'une ligne de résultat (renvoyé par le backend, pour le drill-down). */
export interface RowMemberInfo {
  /** ex. "[Date].[Calendrier].[Annee].&[2025]" */
  uniqueName: string;
  /** ex. "[Date].[Calendrier].[Annee]" */
  levelName: string;
  /** 0 = membre « All », 1 = premier niveau… */
  levelDepth: number;
}

/** Membre d'une colonne de données (mesure ou membre d'une dimension en colonnes). */
export interface ColumnMemberInfo {
  uniqueName: string;
  caption: string;
  /** 0 = membre « All » : colonne de total calculée par SSAS. */
  levelDepth: number;
  isMeasure: boolean;
}

export interface QueryResult {
  columns: string[];
  rows: any[][];
  /** Une entrée par ligne de `rows` (absent sur les anciens backends). */
  rowMembers?: RowMemberInfo[][];
  /** Une entrée par colonne de données (absent sur les anciens backends). */
  columnMembers?: ColumnMemberInfo[][];
}

/** Élément glissé entre la liste des dimensions et les zones lignes/colonnes. */
export interface DragPayload {
  source: "rows" | "columns" | "list";
  index?: number;
  sel: DimensionSelection;
}
